/**
 * Error Types
 */

//Using ASYNC as a convention to know that I'll have three types.
export const SET_ERROR = "ERROR/SET_ERROR";
export const RESET_ERROR_VALUES = "ERROR/RESET_ERROR_VALUES";



// WEBPACK FOOTER //
// ./src/modules/ErrorManage/types.js